import styled, { css } from 'styled-components'

const title = css`
  color: ${({ theme }) => theme.colors.textContent};
  font-weight: bold;
  font-size: 17px;
  margin-left: 15px;
`

export const StyledIncomeContainer = styled.section`
  margin-top: 50px;
  .title {
    ${title}
  }
`
export const StyledIncomeDataContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .data-container {
    padding: 20px 30px;
    margin: 0;

    .content {
      line-height: 27px;
      margin-top: 15px;
    }
  }

  .charge-fee > .content {
    color: #feb61d;
  }
  @media screen and (max-width: 640px) {
    display: flex;
    flex-direction: column;
    margin: 0;

    .data-container {
      margin: 0;
      margin-bottom: 15px;
      .content {
        font-size: 21px;
      }
    }
  }
`
